import React from 'react';
import {Link} from 'react-router-dom';
import Tooltip2 from '../../../uiToolkit/Tooltip2/Tooltip2';

interface Props {
  url: string;
  text: string;
  icon: string;
  disabled?: boolean;
  tooltipText?: string;
}

const QuickLink = React.memo(
  ({url, text, icon, disabled = false, tooltipText}: Props) => {
    return (
      <Tooltip2 text={tooltipText || ''} hidden={!disabled}>
        <Link
          to={disabled ? '' : url}
          className={`QuickLink ${disabled ? 'QuickLinkDisabled' : ''}`}>
          <span className={`${icon} Icon`}></span>
          <span>{text.split(' ')[0]}</span>
          <span>{text.split(' ')[1]}</span>
        </Link>
      </Tooltip2>
    );
  },
);

export default QuickLink;
